import React from "react";

import Button from "components/ui/Button";

// Status message + Save button under an account form.
export default function SaveBar({ status, error }) {
  return (
    <div className="yc-account-save">
      {status === "saved" && <p className="yc-alert is-success" role="status">Changes saved.</p>}
      {error && <p className="yc-alert is-error" role="alert">{error}</p>}
      <Button type="submit" size="lg" disabled={status === "saving"}>
        {status === "saving" ? "Saving…" : "Save"}
      </Button>
    </div>
  );
}
